import type { DrawingTypes } from './drawing.interface'
import type DrawingBase from './drawing.base'

type DrawingClassMap = Record<DrawingTypes, typeof DrawingBase<any, any, any>>

let drawingClassMap: DrawingClassMap | undefined
let loadingDrawingClassMap: Promise<DrawingClassMap> | undefined

export function initDrawingClassMap(map: DrawingClassMap) {
    drawingClassMap = map
}

export function isDrawingClassMapReady(): boolean {
    return drawingClassMap !== undefined
}

/**
 * The drawing tool classes are the largest self-contained part of the chart code, so they
 * ship as their own chunk instead of in the entry bundle. `drawing.constants` registers the
 * map when it evaluates; this starts (or joins) that load. Callers that need a class
 * synchronously check `isDrawingClassMapReady()` and retry once this promise resolves.
 */
export function loadDrawingClassMap(): Promise<DrawingClassMap> {
    if (drawingClassMap) return Promise.resolve(drawingClassMap)
    if (!loadingDrawingClassMap) {
        loadingDrawingClassMap = import('./drawing.constants')
            .then(() => getDrawingClassMap())
            .catch((error) => {
                // Leave the promise unset so a later call retries the network load.
                loadingDrawingClassMap = undefined
                throw error
            })
    }
    return loadingDrawingClassMap
}

export function getDrawingClassMap(): DrawingClassMap {
    if (!drawingClassMap) {
        throw new Error('Drawing class map is not initialized')
    }
    return drawingClassMap
}

export function getDrawingClass(type: DrawingTypes): typeof DrawingBase<any, any, any> {
    return getDrawingClassMap()[type]
}
